import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=55438796&scoped=true&"
import script from "./activityPage.vue?vue&type=script&lang=ts&"
export * from "./activityPage.vue?vue&type=script&lang=ts&"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=55438796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55438796",
  null
  
)

export default component.exports